import {Injectable} from '@angular/core';
import {timer} from 'rxjs';
import {take} from 'rxjs/operators';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {Platform} from '@angular/cdk/platform';
import {PwaPromptComponent} from "../components/pwa-prompt/pwa-prompt.component";
import {pwsInstallsType} from "../interfaces";
import {Lib} from "../../libs/Lib";

@Injectable({
    providedIn: 'root'
})
export class PwaPromptService {
    private promptEvent: any;
    private m_mobileType: pwsInstallsType;

    constructor(private bottomSheet: MatBottomSheet, private platform: Platform) {
    }

    initPwaPrompt() {
        // console.log('platform is this ' + JSON.stringify(this.platform));
        if (this.platform.IOS) {
            // console.log('pwa ios');
            const isInStandaloneMode = ('standalone' in window.navigator) && (window.navigator['standalone']);
            if (!isInStandaloneMode) {
                this.m_mobileType = 'ios';
                // this.openPromptComponentDelay();
            }
        } else if (this.platform.ANDROID || this.platform.isBrowser) {
            // console.log('pwa android | web');
            window.addEventListener('beforeinstallprompt', (event: any) => {
                event.preventDefault();
                this.promptEvent = event;
                this.m_mobileType = 'android';
                // this.openPromptComponentDelay();
            });
        } else if (this.platform.isBrowser) {
            window.addEventListener('beforeinstallprompt', (event: any) => {
                // console.log('pwa web based');
                event.preventDefault();
                this.promptEvent = event;
                this.m_mobileType = 'web';
                // this.openPromptComponentDelay();
            });
        } else {
            console.log('not providing pwa');
        }
    }

    public pwaManuallyOpenPrompt() {
        this.bottomSheet.open(PwaPromptComponent, {data: {mobileType: this.m_mobileType, promptEvent: this.promptEvent}, panelClass: 'pwa-bottom-sheet'});
    }

    public pwaAutoOpenPrompt() {
        // if (Lib.DevMode()) return;
        timer(120000)
            .pipe(take(1))
            .subscribe(() => {
                this.bottomSheet.open(PwaPromptComponent, {data: {mobileType: this.m_mobileType, promptEvent: this.promptEvent}, panelClass: 'pwa-bottom-sheet'});
            });
    }
}
